import { InlineButton } from '@picsart/design-system/components/InlineButton';
import { IconChevronRight } from '@picsart/design-system/foundation/icons/IconChevronRight';

import { useTranslator } from '@picsart/rc/services/localization';
import EffectCard from '@/components/EffectCard';

import useStyles from './styles';
import type { CategoryRowProps } from './types';

const CategoryRow = ({
  category,
  title,
  items,
  itemsPerRow,
  onPresetClick,
  onSeeAll,
}: CategoryRowProps) => {
  const classes = useStyles();
  const translate = useTranslator();

  const previewItems = items.slice(0, itemsPerRow);
  const showSeeAll = items.length > itemsPerRow;
  return (
    <section className={classes.section}>
      <div className={classes.header}>
        <h3 className={classes.title}>{title}</h3>
        {showSeeAll && (
          <InlineButton
            className={classes.seeAllButton}
            size="small"
            endIcon={IconChevronRight}
            onClick={() => onSeeAll(category)}
            isWithoutBorder
            isWithoutBackground
            dataTestId={`see-all-${category}`}
          >
            {translate('See all')}
          </InlineButton>
        )}
      </div>
      <div className={classes.row}>
        {previewItems.map((item) => (
          <div key={item.id} className={classes.cell}>
            <EffectCard
              item={item}
              onClick={() => onPresetClick(item.slug, category)}
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default CategoryRow;
